import { Directive } from '@angular/core';

@Directive({
  selector: '[mriUiBadgeText]',
  standalone: true
})
export class UiBadgeTextDirective {}
